import { axiosInstance } from '../shared/services/axios-instance'
import * as endpoints from '@/constants/api-constants'

export default class SignService {
  static postSign(competitionId: number, description: string, config: any) {
    return axiosInstance.post(
      endpoints.postConcourseParticipation,
      {
        competitionId,
        description,
      },
      config
    )
  }
  static getUserSign(competitionId: number, config: any) {
    return axiosInstance.get(
      endpoints.getConcourseParticipation + competitionId,
      config
    )
  }

  static getTotalSigns(competitionId: number) {
    return axiosInstance.get(
      endpoints.getAccumulationsTotal + competitionId
    )
  }
}
